"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturingBundleSchema = void 0;
exports.FeaturingBundleSchema = {
    "$id": "https://www.redbull.com/schemas/featuring-bundles.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FeaturingBundle",
    "description": "Stores featured content resources for a given locale / context",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:featuring-bundles:([a-zA-Z0-9\\d\\-_]+)$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:featuring-bundles"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "createdBy": {
                    "type": "string",
                    "description": "User in the featuring-app who created a featuring record"
                },
                "effectiveDate": {
                    "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
                    "description": "the start date from when on the featuring bundle will become active."
                },
                "subTypes": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "description": "the subtypes included in the bundle"
                },
                "updatedBy": {
                    "type": "string",
                    "description": "User in the featuring-app who changed a featuring record"
                }
            },
            "required": [
                "effectiveDate"
            ]
        },
        "relationships": {
            "type": "object",
            "required": [
                "primaryLocale"
            ],
            "properties": {
                "primaryLocale": {
                    "type": "object",
                    "description": "the primary locale for which this featuring bundle is designed for",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "required": [
                                    "id",
                                    "type"
                                ],
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:locales:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:locales"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "patternProperties": {
                "^(?!primaryLocale)[a-zA-Z]+$": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "required": [
                                    "id",
                                    "type"
                                ],
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^(rrn:content(:([a-z\\-]+)))(:[a-zA-Z0-9\\d\\-_]+)?$"
                                    },
                                    "type": {
                                        "type": "string",
                                        "pattern": "^rrn:master:([a-z\\-]+)$"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "meta": {
            "type": "object",
            "additionalProperties": true
        }
    },
    "required": [
        "id",
        "type",
        "attributes",
        "relationships"
    ]
};
//# sourceMappingURL=data:application/json;base64,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